import React, { useState } from 'react';
import CustomerLogin from './CustomerLogin';
import CustomerRegister from './CustomerRegister';
import './CustomerAuthModal.css';

const CustomerAuthModal = ({ isOpen, onClose }) => {
  const [currentView, setCurrentView] = useState('login');

  if (!isOpen) return null;

  const switchToRegister = () => setCurrentView('register');
  const switchToLogin = () => setCurrentView('login');

  return (
    <div className="customer-auth-overlay">
      <div className="customer-auth-modal">
        {currentView === 'login' ? (
          <CustomerLogin 
            onClose={onClose} 
            onSwitchToRegister={switchToRegister}
          />
        ) : (
          <CustomerRegister 
            onClose={onClose} 
            onSwitchToLogin={switchToLogin}
          />
        )}
      </div>
    </div>
  );
};

export default CustomerAuthModal;
